/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */

import PaletteIconBullet from '@telus-uds/palette-koodo/build/rn/icons/Bullet'
const theme = {
  appearances: {
    compact: {
      description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
      type: 'variant',
      values: [ true ]
    },
    size: {
      description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
      type: 'variant',
      values: [ 'large', 'small' ]
    }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: {
        iconMarginTop: 4,
        itemFontSize: 20,
        itemIconSize: 20,
        itemLineHeight: 1.4
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        iconMarginTop: 0,
        itemFontSize: 14,
        itemIconSize: 20,
        itemLineHeight: 1.42857142857
      }
    },
    {
      if: { compact: true },
      tokens: { iconMarginTop: 1, itemLineHeight: 1.25 }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { itemLineHeight: 1.14285714286 }
    },
    {
      if: { compact: true, size: 'large' },
      tokens: { itemLineHeight: 1.3 }
    }
  ],
  tokens: {
    bulletIcon: PaletteIconBullet,
    dividerColor: '#c9c8c8',
    dividerSize: 1,
    iconMarginTop: 2,
    interItemMargin: 8,
    interItemMarginWithDivider: 16,
    itemBulletColor: '#000000',
    itemBulletContainerAlign: 'center',
    itemBulletContainerHeight: 20,
    itemBulletContainerWidth: 24,
    itemFontName: 'StagSans',
    itemFontSize: 16,
    itemFontWeight: '400',
    itemIconColor: '#000000',
    itemIconSize: 20,
    itemLineHeight: 1.5,
    itemTextColor: '#000000',
    listGutter: 8
  }
}
export default theme
